import styled from "styled-components";

export const Section = styled.section`
  padding-top: 4rem;
  padding-bottom: 4rem;
  background-color: #f9fafb;

  @media (min-width: 768px) {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;

  @media (min-width: 640px) {
    max-width: 640px;
  }

  @media (min-width: 768px) {
    max-width: 768px;
  }

  @media (min-width: 1024px) {
    max-width: 1024px;
  }

  @media (min-width: 1280px) {
    max-width: 1280px;
  }

  @media (min-width: 1536px) {
    max-width: 1536px;
  }
`;

export const TitleContainer = styled.div`
  max-width: 48rem;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 3rem;
`;

export const Tag = styled.span`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background-color: #e0f2fe;
  color: ${({ theme }) => theme.colors.primary[3]};
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 1rem;
`;

export const Title = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primaryText[9]};
  margin-bottom: 1.5rem;

  @media (min-width: 768px) {
    font-size: 2.25rem;
  }
`;

export const Description = styled.p`
  font-size: 1.125rem;
  color: #4b5563;
`;

export const FaqList = styled.div`
  max-width: 48rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FaqItem = styled.div`
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

export const QuestionButton = styled.button<{ $isOpen?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: transparent;
  border: none;
  text-align: start;
  cursor: pointer;

  font-size: 1.0625rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primaryText[9]};

  svg {
    flex-shrink: 0;
    transition: transform 0.3s ease;
    color: ${({ theme }) => theme.colors.primary[3]};
    transform: rotate(${({ $isOpen }) => ($isOpen ? "180deg" : "0deg")});
  }
`;

export const AnswerWrapper = styled.div<{ $isOpen?: boolean }>`
  display: grid;
  grid-template-rows: ${({ $isOpen }) => ($isOpen ? "1fr" : "0fr")};
  transition: grid-template-rows 0.3s ease;
`;

export const AnswerInner = styled.div`
  overflow: hidden;
`;

export const Answer = styled.p`
  margin: 0;
  padding: 0 1.5rem 1.25rem;
  color: ${({ theme }) => theme.colors.primaryText[8]};
  line-height: 1.6;

  a {
    color: ${({ theme }) => theme.colors.primary[3]};
    text-decoration: underline;
  }
`;
